import styled from '@emotion/styled';

export const Message = styled.p`
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  padding: 5px 0;
  color: rgb(55, 90, 99);
`;